import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { setGift } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface SetGiftState {
  setgift: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: SetGiftState = {
  setgift: [],
  status: "idle",
};

export const GetSetGift = createAsyncThunk(
  "setGift",
  async (data: any) => {
    const response = await setGift(data);
    return response;
  }
);

export const setGiftSlice = createSlice({
  name: "setGift",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSetGift.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetSetGift.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!", "error");
      })
      .addCase(GetSetGift.fulfilled, (state, action) => {
        state.status = "success";
        state.setgift = action.payload;
        swal("Record saved success!", "success");
      });
  },
});

export const {} = setGiftSlice.actions;

export const selectSetGift = (state: RootState) => {
  return state.setNewGift.setgift;
};

export default setGiftSlice.reducer;
